export var selectBackgroundStyle = function(style) {
    return style;
};
